// extracted by mini-css-extract-plugin
export default {"inputFile":"file-upload_inputFile__1t5Tf","dropZone":"file-upload_dropZone__diBlC"};